import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, map, Observable, Subject, take, takeUntil } from 'rxjs';
import { LgvAPIService, LgvClientService, LgvUserService, NotificationService } from '../../core/core.module';
import { LgvPublicRecordModel } from '../../data-models/lgv-publicRecord.model';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lgv-public-records-modal',
    templateUrl: './public-records-modal.component.html',
    styleUrls: ['./public-records-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicRecordsModalComponent implements OnInit {

    pageMode$ = new BehaviorSubject('Show_History');
    get showHistory$(): Observable<boolean> { return this.pageMode$.pipe(takeUntil(this.onDestroy$), map(x => x === 'Show_History')) }
    get showSelectedPR$(): Observable<boolean> { return this.pageMode$.pipe(takeUntil(this.onDestroy$), map(x => x === 'Show_SelectedPR')) }

    isLoading$ = new BehaviorSubject(false);
    //showHistory$ = new BehaviorSubject(true);
    onDestroy$ = new Subject();

    _publicRecordsResult: LgvPublicRecordModel.PublicRecordHistorySearchResult = null;
    publicRecordsResult$ = new BehaviorSubject(this._publicRecordsResult);

    _selectedPublicRecord: LgvPublicRecordModel.PublicRecord = null;
    selectedPublicRecord$ = new BehaviorSubject(this._selectedPublicRecord);


    property: LgvModel.Property;
    clientId: string;

    constructor(
        private http: HttpClient,
        public dialogRef: MatDialogRef<PublicRecordsModalComponent>,
        public lgvClientSvc: LgvClientService,
        public lgvUserSvc: LgvUserService,
        public lgvAPISvc: LgvAPIService,
        public lgvNotificationSvc: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.property = data.property;
        this.clientId = data.clientId;
    }


    ngOnInit(): void {
        this.isLoading$.next(true);
        this.lgvAPISvc.FetchPublicRecordHistory(this.property.propertyInfo.id, this.clientId).pipe(takeUntil(this.onDestroy$)).subscribe(res => {
            this.isLoading$.next(false);
            if (res) {
                this.publicRecordsResult$.next(res);
            }
        },
            err => {
                this.isLoading$.next(false);
                this.lgvNotificationSvc.error(`There was an error fetching public record history`);
            }
        );
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }


    onSearchPublicRecords() {

        if (!this.property) {
            this.lgvNotificationSvc.error("Property required.");
            return;
        }

        this.isLoading$.next(true);

        this.lgvAPISvc.FetchPublicRecordReportByID(this.property?.propertyInfo?.id, this.clientId).pipe(take(1)).subscribe(x => {

            this.isLoading$.next(false);

            if (x) {
                let pr = x['publicRecord'] as LgvPublicRecordModel.PublicRecord;
                this.selectedPublicRecord$.next(pr);
                this.pageMode$.next('Show_SelectedPR');

                // add to cached list as well
                let prs = this.publicRecordsResult$.value?.publicRecords;
                if (prs) {
                    prs.push(x['publicRecord']);
                    this.publicRecordsResult$.next({ publicRecords: prs });
                }

            }
            else {
                console.log('Unable to fetch Public Record');
            }
        },
            (err) => {
                this.selectedPublicRecord$.next(null);
                this.isLoading$.next(false);
                console.log('Error fetching public records:');
                console.log(err);
            });



    }

    onViewPublicRecord(pr: LgvPublicRecordModel.PublicRecord) {
        this.selectedPublicRecord$.next(pr);
        this.pageMode$.next('Show_SelectedPR');
    }

    onCancel() {
        this.dialogRef.close({ action: false });
    }

    onShowHistory() {
        this.pageMode$.next('Show_History');
    }

}
